import { useState } from 'react';
import { yupSchemas } from 'utils';
import ROUTES from 'Routes/routes';
import { useHistory } from 'react-router';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { forgotUsername } from 'api';
import { useAppDispatch } from 'redux/store';
import { pushMessage } from 'redux/reducers/messages';
import ButtonWithLoader from 'components/Buttons/ButtonWithLoader';
import SnackBar from 'components/Indicators/SnackBar';
import { useTheme } from '@mui/system';

const ForgotUsernameForm = () => {
    const dispatch = useAppDispatch();
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [notifyUserMessage, setNotifyUserMessage] = useState('');
    const { push } = useHistory();
    const theme = useTheme();

    const handleSubmit = async (values: { email: string }) => {
        const { email } = values;
        setIsLoading(true);
        try {
            await forgotUsername(email);
            setSuccess(true);
            dispatch(
                pushMessage({
                    status: 'success',
                    message: `Email sent to ${email}`,
                }),
            );
            push(ROUTES.Login.path);
        } catch (err: any) {
            setSuccess(false);
            setNotifyUserMessage('Please try again with a different email.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Formik
            initialValues={yupSchemas.email.getDefault()}
            validationSchema={yupSchemas.email}
            onSubmit={handleSubmit}
        >
            {() => (
                <Form
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Field
                        style={{ width: '100%', marginBottom: theme.spacing(10) }}
                        component={TextField}
                        disabled={isLoading}
                        name="email"
                        type="email"
                        label="Email"
                    />
                    <ButtonWithLoader
                        type="submit"
                        sx={{ width: '100%', marginBottom: theme.spacing(10) }}
                        variant="contained"
                        color="primary"
                        size="large"
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        Email me recovery link
                    </ButtonWithLoader>
                    <SnackBar
                        open={notifyUserMessage ? true : false}
                        message={notifyUserMessage}
                        setOpen={() => {
                            setNotifyUserMessage('');
                        }}
                        severity={success ? 'success' : 'error'}
                    />
                </Form>
            )}
        </Formik>
    );
};

export default ForgotUsernameForm;
